/*
 * Copyright (c) Nexign, JSC, 2020-2021.
 */
/**
 * Get error translation from server error code
 *
 * @author Yakov Gushchin
 * @version 1.14.0
 * @since 1.10.0
 */

import get from 'lodash/get';
import isArray from 'lodash/isArray';

import { IErrorTranslation } from '../types/common/error';

export function getErrorTranslation<T extends IErrorTranslation>(
    serverError: any,
    translation: T,
    defaultMessage?: string,
): string {
    if (!serverError) return defaultMessage || translation.defaultMessage

    const errorCode = serverError.response?.error?.code;
    return translation.codes[errorCode] || defaultMessage || translation.defaultMessage;
}

export function getErrorTranslationFromJson<T extends IErrorTranslation>(
    serverError: any,
    translation: T,
    defaultMessage?: string,
): string[] {
    const errors = JSON.parse(getErrorTranslation(serverError, translation, defaultMessage));
    return isArray(errors) ? errors : [];
}

export function getErrorMessage(serverError: string) {
    return get(serverError, 'response.error.message', '');
}

export function getTranslationFromJson(translation: string): string[] {
    try {
        const translations = JSON.parse(translation);
        return isArray(translations) ? translations : [];
    } catch (e) {
        return [];
    }
}

